import { BASE_PATH as l, BaseAPI as y, operationServerMap as F } from "../base.js";
import { DUMMY_BASE_URL as C, assertParamExists as O, createRequestFunction as d, serializeDataIfNeeded as p, setSearchParams as u, toPathString as h } from "../common.js";
import P from "axios";
var D = function(r) {
  return {
    overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionDetailPage: async (o, t = {}) => {
      O("overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionDetailPage", "overtimeServiceFeeCommissionDetailQueryDTO", o);
      const s = new URL("/merchant/dc/overtime_service_fee_commission/detail/page", C);
      let i;
      r && (i = r.baseOptions);
      const e = {
        method: "POST",
        ...i,
        ...t
      }, m = {}, a = {};
      m["Content-Type"] = "application/json", u(s, a);
      let v = i && i.headers ? i.headers : {};
      return e.headers = {
        ...m,
        ...v,
        ...t.headers
      }, e.data = p(o, e, r), {
        url: h(s),
        options: e
      };
    },
    overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionSummary: async (o, t = {}) => {
      O("overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionSummary", "overtimeServiceFeeCommissionDetailQueryDTO", o);
      const s = new URL("/merchant/dc/overtime_service_fee_commission/summary", C);
      let i;
      r && (i = r.baseOptions);
      const e = {
        method: "POST",
        ...i,
        ...t
      }, m = {}, a = {};
      m["Content-Type"] = "application/json", u(s, a);
      let v = i && i.headers ? i.headers : {};
      return e.headers = {
        ...m,
        ...v,
        ...t.headers
      }, e.data = p(o, e, r), {
        url: h(s),
        options: e
      };
    }
  };
}, c = function(r) {
  const o = D(r);
  return {
    async overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionDetailPage(t, s) {
      var i, e;
      const m = await o.overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionDetailPage(t, s), a = (i = r == null ? void 0 : r.serverIndex) !== null && i !== void 0 ? i : 0, v = (e = F["OvertimeServiceFeeCommissionStatApi.overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionDetailPage"]) === null || e === void 0 || (e = e[a]) === null || e === void 0 ? void 0 : e.url;
      return (n, S) => d(m, P, l, r)(n, v || S);
    },
    async overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionSummary(t, s) {
      var i, e;
      const m = await o.overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionSummary(t, s), a = (i = r == null ? void 0 : r.serverIndex) !== null && i !== void 0 ? i : 0, v = (e = F["OvertimeServiceFeeCommissionStatApi.overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionSummary"]) === null || e === void 0 || (e = e[a]) === null || e === void 0 ? void 0 : e.url;
      return (n, S) => d(m, P, l, r)(n, v || S);
    }
  };
}, x = function(r, o, t) {
  const s = c(r);
  return {
    overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionDetailPage(i, e) {
      return s.overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionDetailPage(i.overtimeServiceFeeCommissionDetailQueryDTO, e).then((m) => m(t, o));
    },
    overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionSummary(i, e) {
      return s.overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionSummary(i.overtimeServiceFeeCommissionDetailQueryDTO, e).then((m) => m(t, o));
    }
  };
}, _ = class extends y {
  overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionDetailPage(r, o) {
    return c(this.configuration).overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionDetailPage(r.overtimeServiceFeeCommissionDetailQueryDTO, o).then((t) => t(this.axios, this.basePath));
  }
  overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionSummary(r, o) {
    return c(this.configuration).overtimeServiceFeeCommissionStatGetOvertimeServiceFeeCommissionSummary(r.overtimeServiceFeeCommissionDetailQueryDTO, o).then((t) => t(this.axios, this.basePath));
  }
};
export {
  _ as OvertimeServiceFeeCommissionStatApi,
  D as OvertimeServiceFeeCommissionStatApiAxiosParamCreator,
  x as OvertimeServiceFeeCommissionStatApiFactory,
  c as OvertimeServiceFeeCommissionStatApiFp
};

//# sourceMappingURL=overtime-service-fee-commission-stat-api.js.map